/** CoStar.Api.EnterpriseSub2.Charting.AnalyticTimeframe */
export var AnalyticTimeframe;
(function (AnalyticTimeframe) {
    AnalyticTimeframe[AnalyticTimeframe["OneYear"] = 0] = "OneYear";
    AnalyticTimeframe[AnalyticTimeframe["ThreeYears"] = 1] = "ThreeYears";
    AnalyticTimeframe[AnalyticTimeframe["FiveYears"] = 2] = "FiveYears";
    AnalyticTimeframe[AnalyticTimeframe["TenYears"] = 3] = "TenYears";
    AnalyticTimeframe[AnalyticTimeframe["All"] = 4] = "All";
    AnalyticTimeframe[AnalyticTimeframe["Unknown"] = -1] = "Unknown";
})(AnalyticTimeframe || (AnalyticTimeframe = {}));
/** CoStar.Api.EnterpriseSub2.Charting.ChartTemplateType */
export var ChartTemplateType;
(function (ChartTemplateType) {
    ChartTemplateType[ChartTemplateType["Unknown"] = 0] = "Unknown";
    ChartTemplateType[ChartTemplateType["OccupancyRate"] = 396] = "OccupancyRate";
    ChartTemplateType[ChartTemplateType["RentalRate"] = 397] = "RentalRate";
    ChartTemplateType[ChartTemplateType["LeasingActivity"] = 398] = "LeasingActivity";
    ChartTemplateType[ChartTemplateType["NetAbsorptionByProperty"] = 399] = "NetAbsorptionByProperty";
    ChartTemplateType[ChartTemplateType["OccupancyAndSaleHistory"] = 400] = "OccupancyAndSaleHistory";
    ChartTemplateType[ChartTemplateType["NetAbsorptionBySubmarket"] = 401] = "NetAbsorptionBySubmarket";
    ChartTemplateType[ChartTemplateType["ConstructionActivity"] = 402] = "ConstructionActivity";
    ChartTemplateType[ChartTemplateType["ComparableSales"] = 403] = "ComparableSales";
})(ChartTemplateType || (ChartTemplateType = {}));
/** CoStar.Api.EnterpriseSub2.Charting.AnalyticChartType */
export var AnalyticChartType;
(function (AnalyticChartType) {
    AnalyticChartType[AnalyticChartType["Unknown"] = 0] = "Unknown";
    AnalyticChartType[AnalyticChartType["OccupancyRate"] = 1] = "OccupancyRate";
    AnalyticChartType[AnalyticChartType["RentalRate"] = 2] = "RentalRate";
    AnalyticChartType[AnalyticChartType["LeasingActivity"] = 3] = "LeasingActivity";
    AnalyticChartType[AnalyticChartType["NetAbsorptionByProperty"] = 4] = "NetAbsorptionByProperty";
    AnalyticChartType[AnalyticChartType["NetAbsorptionBySubmarket"] = 5] = "NetAbsorptionBySubmarket";
    AnalyticChartType[AnalyticChartType["ConstructionActivity"] = 6] = "ConstructionActivity";
    AnalyticChartType[AnalyticChartType["ComparableSales"] = 7] = "ComparableSales";
    AnalyticChartType[AnalyticChartType["OccupancyAndSaleHistory"] = 8] = "OccupancyAndSaleHistory";
})(AnalyticChartType || (AnalyticChartType = {}));
